import * as startApi from "../endpoints/start";

export async function try_GetStart() {
  try {
    const response = await startApi.getStart();
    return response.data;
  } catch (error) {
    console.error("[Service Error]:", error);
    throw error;
  }
}
